import { render, staticRenderFns } from "./SettingsImportant.vue?vue&type=template&id=18750f56&lang=pug&"
import script from "./SettingsImportant.vue?vue&type=script&lang=ts&"
export * from "./SettingsImportant.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports